// import en from '../../../../lang/en-us';
// import TextInput from '../../../../lib/TextField';
// const { dashboard, common } = en;
// import { useEffect, useState } from 'react';
// import { connect } from 'react-redux';
// import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
// import { BANK } from '../../../../redux-store/types/nct';
// import { SubmitButton } from '../../../../lib/Button';
// import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
// import {
//     accountNumberRegex,
//     accountNumberValidation,
//     ACCOUNT_TYPE_MASTER_DATA,
//     getBankAddress,
//     ifscRegex,
//     MINOR_MAJOR,
//     validateIfsc,
// } from '../../../../utils/constants';
// import { RootStateType } from '../../../../redux-store/reducers';
// import {
//     fetchIFSCDetails as getIfscDetails,
//     sendPhoneOTP,
// } from '../../../../redux-store/actions/nct';
// import { NoteModals } from '../../../../lib/NoteModals';
// import { useRef } from 'react';
// import { IfscModal } from '../../../../lib/NoteModals/ifscModal';
// import { ActionHeader, FaqLink } from '..';

import Image from "../../Image";

// export type BANK_DETAILS = {
//     label: string;
//     value: string;
//     name: string;
//     fieldValidation?: any;
//     actionOnBlur?: boolean;
//     isDisabled: boolean;
//     shouldValidateField?: boolean;
//     options?: { label: string; value: string | number }[];
// };

// const initialValues = {
//     accountNo: '',
//     accountType: '',
//     branch: '',
//     city: '',
//     default: '',
//     ifsc: '',
//     micr: '',
//     name: '',
//     neftIfsc: '',
//     pincode: '',
// };

type VALIDATION_UI_PROPS = {
  isValidating: boolean;
  onValidationText: string;
  successfulValidationText: string;
};

export function ValidationUI({
  isValidating = false,
  onValidationText = "Validating",
  successfulValidationText = "Validated",
}: VALIDATION_UI_PROPS) {
  return (
    <div className="ifsc-validating">
      {isValidating ? (
        <>
          <div
            className="spinner"
            style={{
              display: "inline-block",
              marginRight: 10,
            }}
          ></div>
          <span>{onValidationText}</span>
        </>
      ) : (
        <p
          className="successful"
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: 0,
          }}
        >
          <Image
            src="/images/green-tick.svg"
            alt="icon"
            style={{
              marginRight: 10,
            }}
          />
          <span>{successfulValidationText}</span>
        </p>
      )}
    </div>
  );
}

// function MinorStatusEditBank(props: any) {
//     const { Funds: targetFunds, newPan, defaultBank } = props.location.state || {};

//     const notInitialRender = useRef<boolean>(false);
//     const [bankDetails, setBankDetails] = useState<BANK>(initialValues);

//     const [ifscValidation, setValidation] = useState<boolean>(false);

//     const [isDisabled, setDisabled] = useState<boolean>(false);

//     const [showLoader, setLoader] = useState<boolean>(false);

//     const [newDetails, setDetails] = useState<any>({
//         name: '',
//         branch: '',
//         city: '',
//     });

//     const [showModal, setShowModal] = useState<boolean>(false);

//     const [errors, setErrors] = useState<any>({});

//     useEffect(() => {
//         if (!props.location.state) {
//             props.history.push('/');
//             return;
//         }
//         setBankDetails({ ...defaultBank, accountType: 'SAVINGS' });
//     }, []);

//     const ifscCode = bankDetails.ifsc;

//     useEffect(() => {
//         if (ifscCode) {
//             if (notInitialRender.current) {
//                 setLoader(false);
//                 setDisabled(true);
//                 const ifscCode = bankDetails.ifsc;
//                 if (ifscCode.length === 11) {
//                     document.getElementById('ifsc')?.blur();
//                     _getIFSCDetails();
//                 }
//             } else {
//                 notInitialRender.current = true;
//             }
//         }
//     }, [ifscCode]);

//     const handleChange = (value: any, key: string) => {
//         setBankDetails({
//             ...bankDetails,
//             [key]: value,
//         });
//     };

//     const validateForm = () => {
//         let errors: any = {};
//         let formIsValid = true;
//         const firstBank = bankDetails;
//         if (!firstBank.accountNo) {
//             formIsValid = false;
//             errors['accountNo'] = common.errors.bankErrors.accountNo.required;
//         }
//         if (!accountNumberRegex.test(firstBank.accountNo)) {
//             formIsValid = false;
//             errors['accountNo'] = common.errors.bankErrors.accountNo.regexError;
//         }
//         if (!firstBank.ifsc) {
//             formIsValid = false;
//             errors['ifsc'] = common.errors.bankErrors.ifsc.required;
//         }
//         if (!firstBank.ifsc.match(ifscRegex)) {
//             formIsValid = false;
//             errors['ifsc'] = common.errors.bankErrors.ifsc.regex;
//         }
//         if (!firstBank.name) {
//             formIsValid = false;
//             errors['name'] = common.errors.bankErrors.name;
//         }
//         if (
//             !firstBank.accountType ||
//             firstBank.accountType === dashboard.ChangeBank.selectedFolios.fields.accountType
//         ) {
//             formIsValid = false;
//             errors['accountType'] = common.errors.bankErrors.accountType;
//         }
//         if (!firstBank.branch) {
//             formIsValid = false;
//             errors['branch'] = common.errors.bankErrors.branch;
//         }
//         if (!firstBank.city) {
//             formIsValid = false;
//             errors['city'] = common.errors.bankErrors.city;
//         }
//         setErrors(errors);
//         return formIsValid;
//     };

//     const handleSubmit = () => {
//         if (validateForm()) {
//             let bankInfo = targetFunds[0].bank;
//             bankInfo = bankInfo.map((_ele: BANK) => {
//                 if (_ele.default === 'Y') return bankDetails;
//                 return _ele;
//             });
//             props.history.replace('minor-status-list', {
//                 targetFunds: [{ ...targetFunds[0], bank: bankInfo }],
//                 newPan,
//             });
//         }
//     };

//     const removeErrors = () => {
//         setErrors({});
//     };

//     const _handleChangeBankDetails = (
//         bankName: string = '',
//         bankAddress: string = '',
//         city: string = '',
//     ) => {
//         setDetails({
//             name: bankName,
//             branch: bankAddress,
//             city,
//         });
//     };

//     const _handleUpdateDetails = () => {
//         const { name: bankName = '', branch: bankAddress = '', city = '' } = newDetails;
//         setBankDetails({
//             ...bankDetails,
//             name: bankName,
//             branch: bankAddress,
//             city: city,
//         });
//         setShowModal(false);
//         setDisabled(false);
//     };
//     const _getIFSCDetails = async () => {
//         if (bankDetails.ifsc.match(ifscRegex)) {
//             setValidation(true);
//             setLoader(true);
//             const { pan, pekrn, mobile, reqId } = props;
//             try {
//                 let response: any = await props.getIfscDetails({
//                     pan,
//                     pekrn,
//                     mobile,
//                     reqId,
//                     ifscCode: bankDetails.ifsc,
//                 });
//                 const { errors = [], data = [] } = (response || {}).body;
//                 if (errors.length) {
//                     const [firstError] = errors;
//                     throw Error(firstError?.message);
//                 }
//                 const [details] = data;
//                 const { BankAdd1 = '', BankAdd2 = '', BankAdd3 = '' } = details;
//                 _handleChangeBankDetails(
//                     details.BankName,
//                     getBankAddress(BankAdd1, BankAdd2, BankAdd3),
//                     details.BankCity,
//                 );
//                 setDisabled(false);
//                 setValidation(false);
//                 setShowModal(true);
//             } catch (e: any) {
//                 setLoader(false);
//                 setValidation(false);
//                 setDisabled(true);
//                 _handleChangeBankDetails();
//                 setErrors({ ifsc: e.message });
//             }
//         } else {
//             _handleChangeBankDetails();
//             setLoader(false);
//             setValidation(false);
//             setDisabled(true);
//             setErrors({ ifsc: common.errors.bankErrors.ifsc.regex });
//         }
//     };

//     const _handleModalClose = () => {
//         setValidation(false);
//         setLoader(false);
//         setDisabled(true);
//         _handleChangeBankDetails();
//         setShowModal(false);
//         setBankDetails({
//             ...bankDetails,
//             ifsc: '',
//         });
//     };

//     return (
//         <div className="curved-bg">
//             <ActionHeader header={dashboard.MinorStatus.MinorStatusHeading} />
//             <div className="curved-bg-content update-pan-selected-content">
//                 <div className="curved-bg-content-inner minor-review">
//                     <div className="add-new-bankAccount minor-new-bankAccount">
//                         <h4>
//                             {dashboard.MinorStatus.ReviewDetails.editFolioBank}
//                             {/* Put Folio Number HERE */}
//                             {targetFunds[0].folio}
//                         </h4>
//                         <div className="new-bank-fields">
//                             {[
//                                 {
//                                     label: dashboard.MinorStatus.ReviewDetails.fields.accountNumber,
//                                     value: bankDetails.accountNo || '',
//                                     name: 'accountNo',
//                                     fieldValidation: accountNumberValidation,
//                                     isDisabled: false,
//                                 },
//                                 {
//                                     label: dashboard.MinorStatus.ReviewDetails.fields.ifsc,
//                                     value: bankDetails.ifsc || '',
//                                     name: 'ifsc',
//                                     actionOnBlur: true,
//                                     isDisabled: false,
//                                     shouldValidateField: true,
//                                     fieldValidation: validateIfsc,
//                                 },
//                                 {
//                                     label: dashboard.MinorStatus.ReviewDetails.fields.bankName,
//                                     value: bankDetails.name || '',
//                                     name: 'name',
//                                     isDisabled: true,
//                                 },
//                                 {
//                                     label: dashboard.MinorStatus.ReviewDetails.fields.accountType,
//                                     value:
//                                         bankDetails.accountType ||
//                                         dashboard.ChangeBank.selectedFolios.fields.accountType,
//                                     name: 'accountType',
//                                     isDisabled: false,
//                                 },
//                                 {
//                                     label: dashboard.MinorStatus.ReviewDetails.fields.branch,
//                                     value: bankDetails.branch || '',
//                                     name: 'branch',
//                                     isDisabled: true,
//                                 },
//                                 {
//                                     label: dashboard.MinorStatus.ReviewDetails.fields.city,
//                                     value: bankDetails.city || '',
//                                     name: 'city',
//                                     isDisabled: true,
//                                 },
//                             ].map((_ele: BANK_DETAILS, index: number) =>
//                                 _ele.name === 'accountType' ? (
//                                     <FormControl
//                                         variant="outlined"
//                                         error={!!errors[_ele.name]}
//                                         key={index}
//                                     >
//                                         <Select
//                                             labelId="portfolio-sortby-label"
//                                             id="portfolio-sortby"
//                                             name={'accountType'}
//                                             value={_ele.value}
//                                             onChange={(e) => {
//                                                 handleChange(e.target.value, _ele.name);
//                                             }}
//                                             onBlur={removeErrors}
//                                         // readOnly={true}
//                                         >
//                                             <MenuItem
//                                                 value={
//                                                     dashboard.ChangeBank.selectedFolios.fields
//                                                         .accountType
//                                                 }
//                                             >
//                                                 {
//                                                     dashboard.ChangeBank.selectedFolios.fields
//                                                         .accountType
//                                                 }
//                                             </MenuItem>
//                                             {['SAVINGS'].map((type: string) => (
//                                                 <MenuItem value={type} key={type}>
//                                                     {type}
//                                                 </MenuItem>
//                                             ))}
//                                         </Select>
//                                         <FormHelperText
//                                             className={!!errors[_ele.name] ? 'error' : ''}
//                                         >
//                                             {errors[_ele.name]}
//                                         </FormHelperText>
//                                     </FormControl>
//                                 ) : (
//                                     <>
//                                         <FormControl variant="outlined">
//                                             <TextInput
//                                                 key={index}
//                                                 variant="outlined"
//                                                 label={_ele.label}
//                                                 id={_ele.name}
//                                                 value={_ele.value.toUpperCase()}
//                                                 onChange={(e) => {
//                                                     if (_ele.fieldValidation) {
//                                                         _ele.fieldValidation(e.target.value)
//                                                             ? handleChange(
//                                                                 e.target.value,
//                                                                 _ele.name,
//                                                             )
//                                                             : null;
//                                                         return;
//                                                     }
//                                                     handleChange(e.target.value, _ele.name);
//                                                 }}
//                                                 error={!!errors[_ele.name]}
//                                                 helperText={errors[_ele.name]}
//                                                 onBlur={() => removeErrors()}
//                                                 onFocus={() => setErrors({})}
//                                                 disabled={_ele.isDisabled}
//                                                 title={!!_ele.isDisabled ? _ele.value : ''}
//                                             />
//                                             {_ele.shouldValidateField && showLoader && (
//                                                 <FormHelperText>
//                                                     <ValidationUI
//                                                         isValidating={ifscValidation}
//                                                         onValidationText={common.validatingIFSC}
//                                                         successfulValidationText={
//                                                             common.IFSCValidated
//                                                         }
//                                                     />
//                                                 </FormHelperText>
//                                             )}
//                                         </FormControl>
//                                     </>
//                                 ),
//                             )}
//                         </div>
//                         <FaqLink section={MINOR_MAJOR} history={props.history} />
//                         <div className="curved-bg-content-inner-bottom">
//                             <SubmitButton
//                                 style={{ margin: 'auto', maxWidth: '250px', width: '90%' }}
//                                 onClick={handleSubmit}
//                                 className="customBtn"
//                                 label={dashboard.MinorStatus.ReviewDetails.save}
//                                 disabled={isDisabled}
//                             />
//                         </div>
//                         {showModal && (
//                             <IfscModal
//                                 extraClass="ifsc-modal"
//                                 showModal={showModal}
//                                 heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
//                                 info1={'Bank Name'}
//                                 info2={'IFSC Code'}
//                                 info3={'City'}
//                                 info4={'Branch'}
//                                 content1={newDetails.name}
//                                 content2={ifscCode}
//                                 content3={newDetails.city}
//                                 content4={newDetails.branch}
//                                 proceedBtn={'Okay'}
//                                 onProceed={_handleUpdateDetails}
//                                 cancelBtn={'Cancel'}
//                                 onCancel={_handleModalClose}
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
// export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
//     getIfscDetails,
//     sendPhoneOTP,
// })(MinorStatusEditBank);
